import { GemMeterState } from '@/modules/gem-meter/types/types';
import { RootState } from '@/store';
import { GetterTree } from 'vuex';

export enum GetterTypes {
  GETTER_EXAMPLE = 'getterExample',
}

export type RegisteredGetters = {
  [K in keyof Getters]: ReturnType<Getters[K]>;
};
export type Getter<T, S = GemMeterState, R = RootState> = (
  state: S,
  getters: RegisteredGetters,
  rootState: R,
  rootGetters: any,
) => T;

export interface Getters {
  [GetterTypes.GETTER_EXAMPLE]: Getter<boolean>;
}
export const getters: GetterTree<GemMeterState, RootState> & Getters = {
  [GetterTypes.GETTER_EXAMPLE](state: GemMeterState) {
    return !!state.isInitialize;
  },
};
